import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Features from '@/components/Features'
import Tracking from '@/components/Tracking'
import Contacts from '@/components/Contacts'
import Credits from '@/components/Credits'
import OpenTracking from '@/components/OpenTracking'
import Contents from '@/components/Contents'
import PageNotFound from '@/components/PageNotFound'
import Demo from '@/components/Demo'
import Legal from '@/components/Legal'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/features',
      name: 'Features',
      component: Features
    },
    {
      path: '/tracking',
      name: 'Tracking',
      component: Tracking
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/credits',
      name: 'Credits',
      component: Credits
    },
    {
      path: '/opentracking',
      name: 'OpenTracking',
      component: OpenTracking
    },
    {
      path: '/contents',
      name: 'Contents',
      component: Contents
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal
    },
    {
      path: '*',
      name: 'Not found',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js